const ObjectIcon = ({ color = "currentColor" }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <g clipPath="url(#clip0_11388_5214)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.65625 3.15625V2.375C2.65625 2.11625 2.86625 1.90625 3.125 1.90625H11.875C12.1337 1.90625 12.3438 2.11625 12.3438 2.375V3.15625H13.125C13.3837 3.15625 13.5938 3.36625 13.5938 3.625V12.375C13.5938 12.6337 13.3837 12.8438 13.125 12.8438H12.3438V13.625C12.3438 13.8837 12.1337 14.0938 11.875 14.0938H3.125C2.86625 14.0938 2.65625 13.8837 2.65625 13.625V12.8438H1.875C1.61625 12.8438 1.40625 12.6337 1.40625 12.375V3.625C1.40625 3.36625 1.61625 3.15625 1.875 3.15625H2.65625ZM2.34375 11.9062H2.8125C3.01937 11.9062 3.21812 11.9887 3.365 12.135C3.51125 12.2819 3.59375 12.4806 3.59375 12.6875V13.1562H11.4062V12.6875C11.4062 12.4806 11.4887 12.2819 11.635 12.135C11.7819 11.9887 11.9806 11.9062 12.1875 11.9062H12.6562V4.09375H12.1875C11.9806 4.09375 11.7819 4.01125 11.635 3.865C11.4887 3.71812 11.4062 3.51937 11.4062 3.3125V2.84375H3.59375V3.3125C3.59375 3.51937 3.51125 3.71812 3.365 3.865C3.21812 4.01125 3.01937 4.09375 2.8125 4.09375H2.34375V11.9062Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.75 0.96875C14.1813 0.96875 14.5312 1.31875 14.5312 1.75V3.3125C14.5312 3.74375 14.1813 4.09375 13.75 4.09375H12.1875C11.7562 4.09375 11.4062 3.74375 11.4062 3.3125V1.75C11.4062 1.31875 11.7562 0.96875 12.1875 0.96875H13.75Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.75 11.9062C14.1813 11.9062 14.5312 12.2562 14.5312 12.6875V14.25C14.5312 14.6813 14.1813 15.0312 13.75 15.0312H12.1875C11.7562 15.0312 11.4062 14.6813 11.4062 14.25V12.6875C11.4062 12.2562 11.7562 11.9062 12.1875 11.9062H13.75Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.8125 0.96875C3.24375 0.96875 3.59375 1.31875 3.59375 1.75V3.3125C3.59375 3.74375 3.24375 4.09375 2.8125 4.09375H1.25C0.81875 4.09375 0.46875 3.74375 0.46875 3.3125V1.75C0.46875 1.31875 0.81875 0.96875 1.25 0.96875H2.8125Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.8125 11.9062C3.24375 11.9062 3.59375 12.2562 3.59375 12.6875V14.25C3.59375 14.6813 3.24375 15.0312 2.8125 15.0312H1.25C0.81875 15.0312 0.46875 14.6813 0.46875 14.25V12.6875C0.46875 12.2562 0.81875 11.9062 1.25 11.9062H2.8125Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_11388_5214">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ObjectIcon;
